import React from 'react';

import WidgetInput from './WidgetInput';

import BookprocessWidgetProps from './interfaces/BookprocessWidgetPropsInterface';

export default class WidgetTextArea extends WidgetInput<BookprocessWidgetProps> {
    render(): React.DetailedReactHTMLElement<React.HTMLAttributes<HTMLElement>, HTMLElement> {
        return React.createElement('textarea', {
            id: this.props.id,
            name: this.props.name,
            key: this.props.id,
            required: this.props.required,
            value: this.getRenderValue(),
            onChange: this.onChange,
        });
    }

    onChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(this.props.name, event.target.value, false);
    }
}
